<script>
    import { fly } from "svelte/transition";
    import { Toast, notify, Button } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Button on:click={() => notify.show("Hello world")}>轻提示</Button>
    </div>
    <h4 class="example-title">不同的颜色状态</h4>
    <div class="example-body">
        <Button on:click={() => notify.show("轻提示")}>轻提示</Button>
        <Button color="success" on:click={() => notify.success("成功")}
            >成功</Button
        >
        <Button color="primary" on:click={() => notify.info("info")}
            >info</Button
        >
        <Button color="danger" on:click={() => notify.danger("错误")}
            >错误</Button
        >
        <Button color="warning" on:click={() => notify.warning("警告")}
            >警告</Button
        >
    </div>
    <Toast />
</div>

<style lang="less">
    @import "./example.less";
</style>
